import React from 'react';
import { Select } from 'antd';

const SelectGender = ({ showUninformed = true, ...rest }) => {
  return (
    <Select
      {...rest}
      optionFilterProp="children"
      filterOption={(input, option) =>
        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      {showUninformed ? (
        <Select.Option key="uninformed" value="uninformed">
          Não informado
        </Select.Option>
      ) : null}
      <Select.Option key="male" value="male">
        Masculino
      </Select.Option>
      <Select.Option key="female" value="female">
        Feminino
      </Select.Option>
    </Select>
  );
};

export default SelectGender;
